import { render } from "./KryptonPhoneInput.vue?vue&type=template&id=16033f9c&lang=pug"
import script from "./KryptonPhoneInput.vue?vue&type=script&lang=js"
export * from "./KryptonPhoneInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__